module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-14.17581479.png";